import Vue from 'vue'
import Vuex from 'vuex'
import s3Url from "../../configs/s3url"
Vue.use(Vuex);

const env = process.env.NODE_ENV;
let API_URL = window.location.origin + "/api/";
if(env === "development") {
  API_URL = `${window.location.protocol}//${window.location.hostname}:1337/`;
}

export const store = new Vuex.Store({
  state: {
    env: env,
    loggedIn: false,
    jwt: localStorage.getItem('jwt') || '',
    user: {},
    API_URL: API_URL,
    s3Url: s3Url,
    filteredLink: "demo",
    search: '',
    filters: {
      category: [],
      tag: [],
      has_quiz: false,
      has_labels: false,
      grade: 0,
      min_slides: 1,
      max_slides: 100
    },
    filtersChanged: false,
    loginRedirect: false,
    libLoading: true,
    allLoaded: false,
    libraryItems: [],
    mobileMenuActive: false,
    classes: [
    ]
  },
  actions: {
    authRequest({commit, dispatch}, user) {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        Vue.axios({url: user.url, data: {
            identifier: user.identifier,
            password: user.password
          }, method: user.method })
          .then(resp => {
            console.log(resp);
            if (resp.data.jwt) {
              const token = resp.data.jwt;
              const user = resp.data.user;
              localStorage.setItem('jwt', token) // store the token in localstorage
              localStorage.setItem('jwtReset1', true);
              Vue.axios.defaults.headers.common['Authorization'] = 'Bearer '+token;
              commit('authSuccess')
              commit('setToken', token)
              commit('setUser', user)
              resolve(resp)
            } else {
              resolve({error: "Only @embibe.com email addresses are allowed."})
            }

          })
          .catch(err => {
            // commit(AUTH_ERROR, err)
            localStorage.removeItem('jwt'); // if the request fails, remove any possible user token if possible
            localStorage.removeItem('jwtReset1');
            reject(err)
          })
      })
    },
    authLogOut(ctx) {
      return new Promise((resolve, reject) => { // The Promise used for router redirect in login
        Vue.axios.defaults.headers.common['Authorization'] = '';
        localStorage.removeItem('jwt');
        localStorage.removeItem('jwtReset1');
        ctx.state.user = {};
        ctx.state.loggedIn = false;
        ctx.state.jwt = '';

        resolve()
      })
    }
  },
  getters: {
    query: state => {
      let query = {};
      if (state.search.length) {
        query.search = state.search;
      }
      for (let key in state.filters) {
        if (Array.isArray(state.filters[key]) && state.filters[key].length) {
          query[key] = state.filters[key].map( (f) => {return f.name}).join(",");
        }
      }
      return query;
    }
  },
  mutations: {
    setState(state, data) {
      for (let key in data) {
        state[key] = data[key];
      }
    },
    setFilters(state, filters) {
      state.filters = filters;
    },
    authSuccess(state) {
      state.loggedIn = true;
    },
    logOut(state) {
      state.loggedIn = false;
    },
    setToken(state, token) {
      state.jwt = token;
    },
    setUser(state, user) {
      state.user = user;
    }
  },
});



// WEBPACK FOOTER //
// ./src/store.js